<template>
  <div class="home-banner relative h-[348px] mb-[110px] flex-none">
    <div class="home-banner-bg absolute inset-0">
      <img
        class="w-full h-full object-cover absolute top-0 left-0"
        src="../assets/img/jjfa-bg.png"
        alt=""
      />
    </div>
    <div
      class="home-banner-content content text-center relative h-full flex items-center"
    >
      <div>
        <h1 class="text-[46px] font-extrabold mb-[20px]" style="color: #1a1a1a">
          司普AI大模型，驱动数智升级
        </h1>
        <h2
          style="color: rgba(47, 52, 67, 0.48)"
          class="text-[20px] font-medium mb-[40px]"
        >
          通用生成式AI+垂直行业解决方案赋能你我的工作和生活
        </h2>
        <n-button type="primary" size="large" class="btn rounded">
          预约演示
        </n-button>
      </div>
    </div>
  </div>
  <div class="about-us content">
    <div class="title">公司简介</div>
    <div class="flex h-[383px] justify-center ggjj w-full gap-[40px]">
      <div class="left w-[471px] h-[314px]">
        <img
          class="w-full h-full object-cover"
          src="../assets/img/about-us.png"
          alt=""
        />
      </div>
      <div class="right">
        深圳市司普科技有限公司是一家行业智能化解决方案综合服务商，目前旗下拥有智能OCR/NLP数采平台、数字助理系统两大产品。依托“LLM+Agent”的产品架构，推出了数据治理、智能问答、专家智能写作、智能搜索、智能报表等产品，成功运用于智能核保、智能销售、智能偏差写作、企业信息库、知识图谱搜索等业务场景。截止当前，司普已广泛服务于保险金融、医疗健康、教育培训、电力新能源等领域龙头企业，服务客户年营收规模超过1000亿美元。
      </div>
    </div>
    <div class="title mb-[30px]">团队简介</div>
    <div class="flex mb-[120px] gap-[89px] items-center">
      <div class="w-[612px] h-[380px] tdjj">
        公司拥有一支专业的博士科研团队，来自中科大、国科大等顶尖院校学府、科研机构或人工智能明星企业，多人在AI算法竞赛榜单排名前列。
        核心团队从业经验超10年，在AI算法研究、模型训练、数据处理及IT架构等领域拥有深厚沉淀。此外，公司还和国内外一流高校及科研院所保持深度交流与合作，推动科研创新和人才高质量发展。

        <br />
        <br />
        <p>企业文化</p>

        使命——赋科技以人性<br />
        愿景——让天下没有枯燥的工作<br />
        价值观——专业、坦诚、价值创造
      </div>
      <div class="w-[375px] h-[323px] bg-[#D8D8D8]">
        <img
          class="w-full h-full object-cover"
          src="../assets/img/xiezuo.png"
          alt=""
        />
      </div>
    </div>
  </div>
  <div class="bg-[#F6F8FB]">
    <div class="content">
      <div
        class="title mb-[148px] font-bold pt-[110px] text-center"
        style="font-size: 30px; color: #020a1a; line-height: 38px"
      >
        发展历程
      </div>
      <div class="flex items-end relative">
        <div class="fflc-item mb-[90px]">2018</div>
        <div class="fflc-item mb-[136px]">2019</div>
        <div class="fflc-item mb-[182px]">2020</div>
        <div class="fflc-item mb-[228px]">2021</div>
        <div class="fflc-item mb-[274px]">2022</div>
        <div class="fflc-item mb-[320px]">2023</div>
        <div class="fflc-item-desc absolute left-[14px] bottom-[154px]">
          <div class="title">搭建算法模型</div>
          <div class="desc">研发新一代语义理解的NLP算法</div>
        </div>
        <div class="fflc-item-desc absolute left-[190px] bottom-[30px]">
          <div class="title">技术升级</div>
          <div class="desc">北大智库百亿级别文本结构化处理</div>
        </div>
        <div class="fflc-item-desc absolute left-[366px] bottom-[246px]">
          <div class="title">技术延伸</div>
          <div class="desc">
            创维知识图谱商业化、大规模知识图谱计算
            大规模中文语义理解、文本结构化平台
          </div>
        </div>
        <div class="fflc-item-desc absolute left-[543px] bottom-[94px]">
          <div class="title">文本结构化产品</div>
          <div class="desc">
            司普科技成立 OCR处理、表格提取 病历识别、检查报告识别
          </div>
        </div>
        <div class="fflc-item-desc absolute left-[705px] bottom-[338px]">
          <div class="title">开始商业化</div>
          <div class="desc">行业知识库 智能核保、智能理赔、归一化</div>
        </div>
        <div class="fflc-item-desc absolute left-[901px] bottom-[107px]">
          <div class="title">业务场景拓展</div>
          <div class="desc">
            智能偏差写作、专家写作、智能运维、智能核保
            阶段：基础算法研发非结构化文本应用和优化场景化应用
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="lxwm mt-[120px] mb-[150px] content flex gap-[24px]">
    <div class="left">
      <div class="title">联系我们</div>
      <div class="desc">业务咨询请填写表单，我们会尽快给你答复</div>
      <img
        class="2-[457px] h-[282px] object-cover"
        src="../assets/img/lxwm-1.png"
        alt=""
      />
    </div>
    <div class="right">
      <form class="lxwm-form" @submit.prevent="handleSubmit">
        <div class="form-group">
          <label>
            <span style="color: #f56c6c; margin-right: 4px">*</span>您的姓名
            <input
              type="text"
              class="form-input"
              v-model="formData.name"
              placeholder=""
            />
          </label>
        </div>
        <div class="form-group">
          <label>
            <span style="color: #f56c6c; margin-right: 4px; opacity: 0">*</span
            >您的公司
            <input
              type="text"
              class="form-input"
              v-model="formData.company"
              placeholder=""
            />
          </label>
        </div>
        <div class="form-group">
          <label>
            <span style="color: #f56c6c; margin-right: 4px; opacity: 0">*</span
            >您的职位
            <input
              type="text"
              class="form-input"
              v-model="formData.position"
              placeholder=""
            />
          </label>
        </div>
        <div class="form-group">
          <label>
            <span style="color: #f56c6c; margin-right: 4px">*</span>您的电话
            <input
              type="text"
              class="form-input"
              v-model="formData.phone"
              placeholder=""
            />
          </label>
        </div>
        <div class="form-group" style="margin-bottom: 32px">
          <label>
            <span style="color: #f56c6c; margin-right: 4px">*</span>咨询详情
            <textarea
              class="form-textarea"
              v-model="formData.details"
              placeholder=""
            ></textarea>
          </label>
        </div>
        <button
          type="submit"
          :disabled="isSubmitting"
          style="
            width: 100%;
            height: 48px;
            background: #1677ff;
            color: #fff;
            font-size: 20px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          "
        >
          {{ isSubmitting ? '提交中...' : '提交' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import axios from 'axios'
import { API_URLS } from '~/constants/api'

// 获取 message 实例
const message = useMessage()

// 表单数据
const formData = ref({
  name: '',
  company: '',
  position: '',
  phone: '',
  details: ''
})

// 提交状态
const isSubmitting = ref(false)

// 提交表单
const handleSubmit = async () => {
  // 简单验证
  if (
    !formData.value.name ||
    !formData.value.phone ||
    !formData.value.details
  ) {
    message.error('请填写必填项：姓名、电话、咨询详情')
    return
  }

  try {
    isSubmitting.value = true

    const apiUrl = API_URLS.demo()
    console.log('请求地址:', apiUrl)
    console.log('请求数据:', formData.value)

    const response = await axios.post(apiUrl, formData.value, {
      headers: {
        'Content-Type': 'application/json'
      },
      timeout: 10000 // 10秒超时
    })

    console.log('响应数据:', response.data)

    if (response.data.code === 0) {
      // 提交成功
      message.success('提交成功！我们会尽快与您联系。')
      // 重置表单
      formData.value = {
        name: '',
        company: '',
        position: '',
        phone: '',
        details: ''
      }
    } else {
      // 提交失败
      message.error(response.data.message || '提交失败，请重试')
    }
  } catch (error: any) {
    console.error('提交失败:', error)
    if (error.response?.data?.message) {
      message.error(error.response.data.message)
    } else if (error.message) {
      message.error(error.message)
    } else {
      message.error('网络请求失败，请检查网络连接')
    }
  } finally {
    isSubmitting.value = false
  }
}
</script>

<style lang="scss" scoped>
.about-us {
  .title {
    font-weight: bold;
    font-size: 30px;
    color: #020a1a;
    line-height: 38px;
    text-align: center;
  }
  .ggjj {
    margin-top: 30px;
    margin-bottom: 110px;
    align-items: center;
    background: #eff2f9;
    .right {
      width: 481px;
      height: 314px;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      line-height: 37px;
    }
  }
  .tdjj {
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    line-height: 37px;
    p {
      color: #020a1a;
      font-weight: bold;
    }
  }
}
.fflc-item {
  width: 176px;
  height: 46px;
  background: #0e61fe;
  font-weight: 500;
  font-size: 20px;
  color: #ffffff;
  line-height: 46px;
  text-align: center;
}
.fflc-item-desc {
  .title {
    font-weight: bold;
    font-size: 22px;
    color: #020a1a;
    line-height: 33px;
    margin-bottom: 16px;
  }
  .desc {
    width: 150px;
    font-weight: 400;
    font-size: 16px;
    color: #646973;
    line-height: 26px;
  }
}
.lxwm {
  .left {
    .title {
      font-weight: bold;
      font-size: 36px;
      color: #333333;
      line-height: 54px;
      margin-bottom: 10px;
    }
    .desc {
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      margin-bottom: 40px;
    }
  }
  .right {
    width: 497px;
    height: 508px;
    padding: 40px;
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.16);
    border-radius: 6px;
    label {
      font-weight: 400;
      font-size: 14px;
      color: #020a1a;
      line-height: 21px;
    }
    .form-input {
      width: 340px;
      height: 38px;
      margin-bottom: 24px;
      display: inline-block;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #cbd1dc;
      padding: 0 10px;
    }
    .form-textarea {
      vertical-align: top;
      width: 340px;
      height: 100px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #cbd1dc;
      padding: 0 10px;
    }
  }
}
</style>
